import { createStore, applyMiddleware } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { type Epic, createEpicMiddleware } from 'redux-observable';
import { debugEnabled } from '@atlassian/jira-common-debug/src/index.tsx';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools/src/index.tsx';
import reducer, { initialState } from './reducer.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (rootOperation: Epic<any, any>) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const middlewares: any = [];

	if (debugEnabled('redux-logger')) {
		// include logger only for development environment
		// eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
		const { logger } = require('redux-logger');
		middlewares.push(logger);
	}

	return createStore(
		enableBatching(reducer),
		initialState,
		composeWithDevtools({ name: 'ScopeSwitcher' })(
			applyMiddleware(...middlewares, createEpicMiddleware(rootOperation)),
		),
	);
};
